// @ts-check
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['NextMeetingsResponse']} NextMeetingsResponse */

/**
 * @param {number} entityId
 * @returns {Promise<NextMeetingsResponse>}
 */
export async function getNextMeetings(entityId) {
  const { data } = await axios.get('/api/engagement-graph-nodes/next-meetings/', {
    params: { entity_id: entityId },
  })
  return data
}

/**
 * @param {{ scopeEntityId: number, groupBy?: string }} options
 * @returns {Promise<any>}
 */
export async function getScopedOpsSummary({ scopeEntityId, groupBy = 'portfolio' }) {
  const { data } = await axios.get('/api/engagement-graph-nodes/ops-summary/', {
    params: { scope_entity_id: scopeEntityId, group_by: groupBy },
  })
  return data
}

/**
 * @param {number} actionId
 * @returns {Promise<void>}
 */
export async function completeAction(actionId) {
  await axios.post(`/api/graph-actions/${actionId}/complete/`, { incomplete: false })
}

/**
 * @param {number} actionId
 * @returns {Promise<void>}
 */
export async function dropAction(actionId) {
  await axios.delete(`/api/graph-actions/${actionId}/`)
}

/**
 * @param {number} nodeId
 * @param {'resolved' | 'dropped'} userStatus
 * @returns {Promise<void>}
 */
export async function setConstraintStatus(nodeId, userStatus) {
  await axios.patch(`/api/engagement-graph-nodes/${nodeId}/`, { user_status: userStatus })
}

/**
 * @param {number} nodeId
 * @param {boolean} prioritized
 * @returns {Promise<any>}
 */
export async function setPriority(nodeId, prioritized) {
  const { data } = await axios.post(`/api/engagement-graph-nodes/${nodeId}/set-priority/`, { prioritized })
  return data
}
